(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartFile', ChartFile);

    ChartFile.$inject = ['$resource', 'DataUtils'];

    function ChartFile ($resource, DataUtils) {
        var resourceUrl =  'api/chart-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByChart': {url: 'api/chart-files/by-chart/:id', method: 'GET', isArray: true},
            'attachFiles': {url: 'api/chart-files/attach-files', method: 'POST', isArray: true},
            'download': {
                url: 'api/chart-files/get-file/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
        });
    }
})();
